module.exports = {"title":"Meus pedidos","paragraph":"Veja abaixo a lista do pedidos realizados","searchPlaceholder":"Filtrar pedidos"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/FirstAccessFollowRequest/data.json
// module id = 2179
// module chunks = 0